module.exports = __webpack_public_path__ + "img/Flag_of_Bahrain.30728ffe.svg";